import ExperimentService from 'business/services/ExperimentService';
import React, { useEffect, useMemo, useState } from 'react';
import ImagingSettingsCard from '../ImagingSettingsCard/ImagingSettingsCard';
import './style.scss';
import { useSelectedDropImageParameters, useLastSelectedWellNavigationDetails } from 'redux/hooks/experiment';
import { WellDetailsStates } from 'business/models/CustomModels';

const ImagingSetting = () => {
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const selectedDropImageParameters = useSelectedDropImageParameters();
  const {wellNum, plateNum, plateID} = wellNavigationDetails || {};
  const {cpId, dropNumber, inspection, regionName} = selectedDropImageParameters || {};
  const [imageSettings, setImageSettings] = useState([]);
  const wellDetails = useMemo(() => {
    return {wellNum, plateNum, plateID, cpID: cpId, dropNumber, inspectionSet: inspection, regionName} as WellDetailsStates
  } , [wellNavigationDetails, selectedDropImageParameters])

  const fetchImageSettings = async () => {
    const imageSettings = await new ExperimentService().getExperimentImageSettings(
      wellDetails,
    );
    setImageSettings(imageSettings);
  };

  useEffect(() => {
    if (wellDetails) {
      fetchImageSettings();
    }
  }, [wellDetails]);

  return (
    <div id='commandpanel-imagingsetting-wrapper' style={{ height: '67vh', overflow: 'auto' }}>
      {imageSettings?.map((imageSetting, i) => (
        <ImagingSettingsCard
          key={`imageSettingCard-${i}`}
          imageSettings={imageSetting.results}
          header={imageSetting.category}
        />
      ))}
    </div>
  );
};
export default ImagingSetting;
